import constants from './constants';
import {getSanitizedSchedule} from './../scheduler/utils';

const initialState = {
  error: null,
  pending: false,
  data: {},
  isSuccesMessageVisible: false,
  isCancelMessageVisible: false,
  eventName: '',
  specialInstructions: null,
  isUpdateMode: false
}

const createSchedule = (state = initialState, action) => {
  switch (action.type) {
    case `${constants.GET_SCHEDULE}_STARTED`:
    case `${constants.CREATE_SCHEDULE}_STARTED`:
    case `${constants.UPDATE_SCHEDULE}_STARTED`:
    case `${constants.CANCEL_SCHEDULE}_STARTED`:
    case `${constants.CONFIRM_SCHEDULE}_STARTED`:
      return {...state, pending: true}

    case `${constants.GET_SCHEDULE}_ENDED`:
    case `${constants.UPDATE_SCHEDULE}_ENDED`:
      case `${constants.CREATE_SCHEDULE}_ENDED`: {
      const {
        name: eventName,
        schedules: schedulesJSON,
        ...rest
      } = action.data.data;

      const schedules = getSanitizedSchedule(schedulesJSON);

      return {
        ...state,
        pending: false,
        isSuccesMessageVisible: action.type !== `${constants.GET_SCHEDULE}_ENDED`,
        eventName,
        schedules,
        ...rest
      }
    }

    case `${constants.CANCEL_SCHEDULE}_ENDED`:
      return {...state, isCancelMessageVisible: true, pending: false, isActive: false}

      case `${constants.CONFIRM_SCHEDULE}_ENDED`:
          const {
              name: eventName,
              schedules: schedulesJSON,
              ...rest
          } = action.data.data;

          const schedules = getSanitizedSchedule(schedulesJSON);

          return {
              ...state,
              pending: false,
              schedules,
              ...rest
          }

      //return {...state, pending: false, ...action.data.data}

    case constants.TOGGLE_UPDATE_MODE:
      return {...state, isUpdateMode: action.data};

    case constants.HIDE_SCHEDULE_CREATION_SUCCESS_MESSAGE:
      return {...state, isSuccesMessageVisible: false}

      case constants.ON_VALUE_CHANGE:
      return {...state, [action.data.name]: action.data.value}
    case constants.RESET_SCHEDULE_CREATION_DATA:
      return initialState;
    default:
      return state;
  }
}

export default createSchedule